export const texten = {
  titleHome: 'Visit Bröllin (preview {version})',
  welcome: 'Welcome to Bröllin!',
  qrInfo:
    'With the button <img src="{qrIcon}" style="height: 1em" /> at the top center, you can scan the QR codes on the buildings around the Bröllin castle grounds to get more information.',
  mapAlt: 'Bröllin map',
  logoAlt: 'Logo',
  homeAlt: 'Home',
  backAlt: 'Back',
  qrAlt: 'QR-Code',
  qrScan: 'Scan QR-Code',
  langSelectTitle: 'Select language',
  langDe: 'Deutsch',
  langEn: 'English',
  langPl: 'Polski',
  close: 'Close',
  navHome: 'Home',
  navMenu: 'Menu',
  navStudio3: 'Studio 3',
  navStudio1: 'Studio 1',
  navStudio2: 'Studio 2',
  navMeadow: 'Meadow',
  navSheepStable: 'Sheep Stable',
  navManor: 'Manor House',
  navCircusSilo: 'Circus Silo, Storage Cross Building',
  navCafe: 'Café',
  navRefectorium: 'Refectorium, Storage Long Building',
  navFlorianHall: 'Florian Vogelfrei Hall, Grain Drying Hall',
  navPolishGerman: 'Polish-German, Large Bull Stable',
  switchToLight: 'Switch to light theme',
  switchToDark: 'Switch to dark theme',
  themeAuto: 'Follow system setting (auto)',
  navAbout: 'About Us',
  noCodeProvided: 'No code provided.',
  noContentFound: 'No content found for code "{code}" in language "{lang}".',
  noContentFoundGeneric: 'No content found for code "{code}".',
  aboutTitle: 'More Links',
  aboutLinkWebsite: 'Website broellin.de',
  aboutApp: 'This app https://brollin.sonabit.de',
  aboutQrAlt: 'QR code for brollin.sonabit.de',
  aboutVersion: 'Version: {version}',
  homeText:
    'The beginnings of the estate date back to the 13th century. In 1850, the Stöwahs family bought Bröllin and converted it into a modern farm with 350 hectares of land. The family was expropriated after the Second World War, during the land reform, and an Agricultural Production Cooperative (German: LPG) was founded in Bröllin. After the LPG was liquidated, the R.A.M.M. Theatre from Berlin rented the premises in search of a venue for their productions. In 1992, schloss bröllin e.V. was founded. The estate was purchased from the Treuhand (a German Democratic Republic trust agency founded prior to the Reunification) and has since operated as an international residence for the performing arts.',
}
